import ClickOutside from 'library/components/click-outside';
import styled from 'styled-components';
import { IconBase } from 'library/styles/icon';
import Colors from 'library/constants/colors';
import { Loader } from '../entity-loader/styles';
import { ShadowHarsh, TransitionConfig } from '../../constants/styles-config';

export const StyledClickOutside = styled(ClickOutside)`
  display: inline-block;
`;

export const SearchContainerStyles = `
  display: flex;
  align-items: center;
  width: 100%;
  
  input {
    width: 100%;
    background: none;
    border: none;
    outline: none!important;
  }
  
  i.icon-search {
    color: ${Colors.violet};
  }
`;

export const SearchInput = styled.div`
  ${SearchContainerStyles};
  width: 100%;
  position: relative;
  z-index: 1;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 48px;
  background-color: ${Colors.shade07};
  box-sizing: border-box;
  transition: background-color ${TransitionConfig};
`;

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  height: 48px;
  position: relative;
  box-sizing: border-box;

  input {
    height: 48px;
  }
  
  ${({ isOpened }) => {
    if (isOpened) {
      return `
        border-radius: 24px 24px 0px 0px;
        box-shadow: ${ShadowHarsh};
        
        ${SearchInput} {
          border-radius: 24px 24px 0px 0px;
          background-color: ${Colors.shade08};
        }
      `;
    }
    return '';
  }}
}
`;

export const StyledClickOutsideContainer = styled(StyledClickOutside)`
  width: 100%;
`;

export const Icon = styled(IconBase)`
  &.icon-search {
    margin-right: -5px;
  }
  &.icon-colors {
    margin-top: -4px;
  }

  ${({ isDisabled }) => isDisabled && `
    display: inline-block;
    color: ${Colors.shade09};
    pointer-events: none;
    text-decoration: none;
    cursor: not-allowed;
  `};
`;

export const InputOptionContainer = styled.div`
  width: 100%;
  min-height: 100px;
  box-sizing: border-box;
  padding-top: 2px;
  position: relative;
  background-color: ${Colors.shade08};
  border-radius: 0px 0px 24px 24px;
  box-shadow: ${ShadowHarsh};
  border-top: 1px solid ${Colors.shade06};
  
  ${Loader} {
    position: absolute;
    height: 100px;
    width: 100%;
    top: 0;
    
    svg {
      width: 55px;
      height: 55px;
    }
  }
  
  p {
    font-weight: normal;
    color: ${Colors.shade03};    
  }
`;

export const ResultInfo = styled.p`
  text-align: center;
`;

export const ResultInfoContainer = styled.div`
  ${ResultInfo} {
    line-height: 2;
  }
`;

export const InputOption = styled.div`
  width: 100%;
  height: 40px;
  background-color: ${Colors.shade08};
  line-height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${Colors.shade07};
  }

  &:last-child {
    margin-bottom: 15px;
    border-radius: 0px 0px 24px 24px;
  }
`;

export const ResultIcon = styled(IconBase)`
  color: ${Colors.violet};
  line-height: 40px;
  margin-left: 10px;
`;
